import { SortItem } from './member.dashboard.license.response';

export class ToChargeItem {
    MemberServiceID: number;
    NextBillingDate: Date;
    Amount: number;
    LicenseID: number;
    LicenseKey: string;
    Credit: Number;
    CCLast4: string;
    CCExpMonth: number;
    CCExpYear: number;
    FullCCNumberAvailable: boolean;
    MemberID: number;
    FirstName: string;
    LastName: string;
    Company: string;
    LastBillingDate: Date;
    SearchDate: Date;
    CCExpiredAtSearchDate: boolean;

    public static FixDates(item: ToChargeItem) {
        item.NextBillingDate = new Date(item.NextBillingDate);
        item.LastBillingDate = new Date(item.LastBillingDate);
        item.SearchDate = new Date(item.SearchDate);
    }

}


export class ToChargeItemArray extends Array<ToChargeItem> {
    public LastSort = new SortItem;

    constructor(...items: ToChargeItem[]) {
        super(...items);
        Object.setPrototypeOf(this, ToChargeItemArray.prototype);
    }

    public static FixDates(items: ToChargeItemArray) {
        items.forEach(x => ToChargeItem.FixDates(x));
    }
}
